import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core'; // Import TranslateService

@Injectable({
    providedIn: 'root',
})
export class DirectionService {
    private directionSubject = new BehaviorSubject<'ltr' | 'rtl'>('rtl');
    direction$ = this.directionSubject.asObservable();
    private currentLanguageSubject = new BehaviorSubject<string>('he');
    currentLanguage$ = this.currentLanguageSubject.asObservable();
    private RTLLanguages = ['he', 'ar'];

    private isDarkModeSubject = new BehaviorSubject<boolean>(false);
    isDarkMode$: Observable<boolean> = this.isDarkModeSubject.asObservable();

    constructor(
        private translateService: TranslateService,
    ) {
        if (localStorage.getItem('language')) {
            this.currentLanguageSubject.next(localStorage.getItem('language'));
        }
        this.currentLanguage$.subscribe((lang) => {
            if (this.RTLLanguages.includes(lang)) {
                this.setDirection('rtl');
            } else {
                this.setDirection('ltr');
            }
        });
    }

    setDirection(dir: 'ltr' | 'rtl') {
        document.documentElement.setAttribute('dir', dir);
        this.directionSubject.next(dir);
    }

    toLanguageDirection(lang: string) {
        this.currentLanguageSubject.next(lang);
        this.translateService.use(lang);
        localStorage.setItem('language', lang);
        localStorage.setItem('hideLangModel', lang);
        document.documentElement.setAttribute('lang', lang);
    }

    setDarkMode(isDarkMode: boolean) {
        this.isDarkModeSubject.next(isDarkMode);
    }
}